import 'styles/views/offers/pages/show/index.scss'
import MarkdownForOffersPage from 'components/markdown_for_offers_page'
import ArticleCards from 'views/articles/pages/components/article_cards'
import RelatedOfferList from './components/related_offer_list'
import { OpenInvitationModalButton } from './components/open_invitation_modal_button'
import { CooperationActionsButton } from './components/cooperation_actions_button'
import { OpenDirectIntroductionModalButton } from "./components/open_direct_introduction_modal_button"
import { OpenInternalScoutModalButton } from "./components/open_internal_scout_modal_button"

declare const window: any

window.Offers = window.Offers || {}
window.Offers.Pages = window.Offers.Pages || {}
window.Offers.Pages.Show = {
  OpenInvitationModalButton,
  MarkdownForOffersPage,
  RelatedOfferList,
  ArticleCards,
  CooperationActionsButton,
  OpenDirectIntroductionModalButton,
  OpenInternalScoutModalButton,
}
